import { render, staticRenderFns } from "./expensePerson.vue?vue&type=template&id=b354cbba&scoped=true"
import script from "./expensePerson.vue?vue&type=script&lang=js"
export * from "./expensePerson.vue?vue&type=script&lang=js"
import style0 from "./expensePerson.vue?vue&type=style&index=0&id=b354cbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b354cbba",
  null
  
)

export default component.exports